import React from 'react';
import PropTypes from 'prop-types';
import { Button, DotsVertical, Edit01, Menu, Table, Trash01 } from '@opendate-app/setlist';

const KillsTable = ({ kills, onEdit, onDelete }) => {
  const columns = [
    { key: 'name', header: 'Name', primary: true },
    { key: 'seats_killed_count', header: 'Seats Killed' },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: kill => (
        <Menu
          placement="bottom-end"
          trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Actions" />}
          items={[
            { icon: Edit01, label: 'Update Kill', onClick: () => onEdit(kill) },
            { icon: Trash01, label: 'Delete Kill', destructive: true, onClick: () => onDelete(kill) }
          ]}
        />
      )
    }
  ];

  return (
    <div className="mb-3">
      <Table columns={columns} data={kills} getRowKey={kill => kill.id} empty="No kills yet." />
    </div>
  );
};

KillsTable.propTypes = {
  kills: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default KillsTable;
